export default function isUserOrganization(user, organizations, organizationId) {
	return (
		["owner", "admin"].includes(user?.permissions?.role) ||
		organizations.some((organization) => organization.id === organizationId)
	);
}
